/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const addSubscriber = async (subscriberEmail, listId, context) => {
  try {
    const nonce = window.wpApiSettings?.nonce;

    const response = await fetch(
      `${window.wpApiSettings?.root || '/wp-json/'}lana-site-config/v1/newsletter/cm/subscribe?` +
        new URLSearchParams({ _wpnonce: nonce, email: subscriberEmail, list: listId }),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.ok) {
      context.showSuccess = false;
      context.showError = true;
      throw new Error('Error subscribing. Please try again later.');
    }

    return await response.json();
  } catch (error) {
    context.showSuccess = false;
    context.showError = true;
    throw error;
  }
};

const {} = store('lana/cm-newsletter', {
  state: {},

  actions: {
    submitForm(event) {
      if (event) {
        event.preventDefault();
      }

      const form = event.target.form;
      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput ? emailInput.value : '';

      const context = getContext();

      // Basic email validation
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        context.showSuccess = false;
        context.showError = true;
        return;
      }

      const listIdInput = form.querySelector('input[name="list"]');
      const listId = listIdInput ? listIdInput.value : '';

      addSubscriber(email, listId, context).then(() => {
        // Show success message
        context.showSuccess = true;
        context.showError = false;
        form.reset();
      });
    },
  },
});
